<div
  class="session-transition"
  [class.session-transition--visible]="authState.isLoggingOut()"
  role="status"
  aria-live="polite"
  [attr.aria-hidden]="!authState.isLoggingOut()"
>
  <div class="session-transition__content">
    <span class="session-transition__spinner" aria-hidden="true"></span>
    <div class="session-transition__message">
      <strong>Signing out...</strong>
      <span>Please wait</span>
    </div>
  </div>
</div>

<div
  id="zoom-root"
  [ngStyle]="zoomStyles"
  [class.session-content--leaving]="authState.isLoggingOut()"
>
  <p-toast position="top-center" [life]="5000" />
  <app-connectivity-banner />
  <router-outlet></router-outlet>
  <app-inactivity-timer-dialog *ngIf="inactivityTimerService.isWarningVisible()" />
</div>
